// @flow

import { fromJS } from 'immutable';

export const GET_LIVE_DETAILS = 'App/LiveAparat/GET_LIVE_DETAILS';
export const GET_LIVE_DETAILS_SUCCESS = 'App/LiveAparat/GET_LIVE_DETAILS_SUCCESS';
export const GET_LIVE_DETAILS_FAIL = 'App/LiveAparat/GET_LIVE_DETAILS_FAIL';
export const CLEAR_LIVE_DETAILS = 'App/LiveAparat/CLEAR_LIVE_DETAILS';

const initialState = fromJS({
  getLiveDetailsLoading: false,
  liveDetails: {},
  getLiveDetailsFail: null,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case GET_LIVE_DETAILS:
      return state.merge({
        getLiveDetailsLoading: true,
        getVideoDetailsFail: null,
      });
    case GET_LIVE_DETAILS_SUCCESS:
      return state.merge({
        getLiveDetailsLoading: false,
        liveDetails: fromJS(action.data),
      });
    case GET_LIVE_DETAILS_FAIL:
      return state.merge({
        getLiveDetailsLoading: false,
        getLiveDetailsFail: fromJS(action.data),
      });
    case CLEAR_LIVE_DETAILS:
      return state.merge({
        getLiveDetailsLoading: false,
        liveDetails: {},
        getLiveDetailsFail: null,
      });
    default:
      return state;
  }
};

export const getLiveDetails = (data : string) => (dispatch : any) =>
  dispatch({ type: GET_LIVE_DETAILS, data });

export const clearLiveDetails = () => ({ type: CLEAR_LIVE_DETAILS });
